const notifications = {
    state: () => ({
        dialogMessage: null,
        dialogMessageVariant: null
    }),
    mutations: {
        SET_DIALOG_MESSAGE(state, { message, variant }) {
            state.dialogMessage = message;
            state.dialogMessageVariant = variant;
        },
        CLEAR_DIALOG_MESSAGE(state) {
            state.dialogMessage = null;
            state.dialogMessageVariant = 'secondary';
        },
    },
    actions: {
        setDialogMessage({ commit }, data) {
            commit('SET_DIALOG_MESSAGE', data);
        },
        clearDialogMessage({ commit }) {
            commit('CLEAR_DIALOG_MESSAGE');
        }
    },
    getters: {
        dialogMessage(state) {
            return state.dialogMessage;
        },
        dialogMessageVariant(state) {
            return state.dialogMessageVariant;
        },
        hasDialogMessage(state) {
            return state.dialogMessage ? true : false;
        },
    }
};

export default notifications;